<template>
  <div class="c-tooltip">{{text}}</div>
</template>
<script>
export default {
  props: ["text"]
};
</script>